import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel
} from "react-bootstrap";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import { getQuestionsList } from "../../../redux/actions/salesPersonActions";
import moment from "moment";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

const history = createBrowserHistory();

class List extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      questionList: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Manage Pending Question List"],
      show: false,
      promoCodeSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      discountAmountSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      descriptionSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      direction: "",
      orderBy: "",
      showDialog: false,
      promoid: "",
      show: false
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.props.getQuestionsList({ page: this.state.currentPage,limit: this.state.limit });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.questionList !== nextProps.questionList) {
      if (nextProps.questionList) {
        const setPageCount =
          nextProps.questionList.total / nextProps.questionList.per_page;
        this.setState({
          questionList: nextProps.questionList.data,
          totalRecords: nextProps.questionList.total,
          perPage: nextProps.questionList.per_page,
          pageCount: setPageCount
        });
      }
    }
  if (this.props.deletedQuestion !== nextProps.deletedQuestion) {
      if (nextProps.deletedQuestion) {
        this.setState({ show: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.deletedQuestion.message);
        this.props.getQuestionsList({page:this.state.currentPage,limit: this.state.limit});
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: searchstring
    };

    if (this.state.search.length !== 0) {
      this.props.getQuestionsList(postData);
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getQuestionsList({ orderBy: orderBy, direction: direction,limit: this.state.limit });
  };

  handleDelete = quesID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(quesID);
        })
      ]
    });
  };

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : ""
    };
    this.props.getQuestionsList(postData);
  };

  confirmDelete = quesID => {
  };

  render() {
    const { currentPage, totalRecords, perPage, pageCount } = this.state;

    let questionListData = this.state.questionList
      ? this.state.questionList
      : [];

    let questRow;
    if (!isEmpty(questionListData)) {
      questRow = this.state.questionList.map((quest, index) => (
        <tbody>
          <tr
            data-toggle="collapse"
            data-target="#demo1"
            className="accordion-toggle"
            key={quest.dealID}
          >
            <td>{quest.merchant}</td>
            <td>{quest.dealText} </td>
            <td>{quest.salesPerson} </td>
          </tr>

          <tr>
            <td Colspan="3">
              <table key={index}>
                <thead>
                  <tr>
                    <th> Questions</th>
                  </tr>
                </thead>
                {Object.keys(quest.questions).map((key, index) => {
                  return (
                    <tbody>
                      <tr key={key}>
                        <td>{quest.questions[key].question} &nbsp;</td>
                        <td>
                          {" "}
                          <Button
                            bsSize="xsmall"
                            bsStyle="info"
                            onClick={() =>
                              this.context.router.history.push(
                                `/question/edit/${quest.questions[key].quesID}`
                              )
                            }
                          >
                            {" "}
                            Answer{" "}
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
              </table>
            </td>
          </tr>
        </tbody>
      ));
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
       <div className="col-lg-12 user-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Pending Questions</header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="clearfix" />
              <div className="row">
                <div className="col-lg-12">
                  <table
                    className="table table-condensed"
                    style={{ borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr>
                        <th>Merchant</th>
                        <th>Offer</th>
                        <th>Sales Rep.</th>
                      </tr>
                    </thead>
                    {questRow}
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  questionList: state.salesPersonReducer.questionList,
  error: state.salesPersonReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  getQuestionsList,
  renderAlert,
  clearAlert
})(List);



// WEBPACK FOOTER //
// ./src/app/views/salesPerson/question/List.js